import React from "react";
import AnimationContainer from "../AnimationContainer/AnimationContainer.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";

import "./LoaderContainer.scss";

const LoaderContainer = ({ isLoading, isPreloader, children }) => {
  return (
    <div className="relative-element">
      <AnimationContainer
        animationOn={!isLoading}
        animationClassName="hide-content"
        containerElementClassName={
          isPreloader ? "preloader-content" : "loading-content"
        }
        isUnmountOnExit={false}
      >
        {children}
      </AnimationContainer>

      <AnimationContainer
        animationOn={!isLoading}
        animationClassName="show-animation"
        isUnmountOnExit={false}
        containerElementClassName={
          isPreloader ? "preloader-animation" : "loading-animation"
        }
      >
        <LoadingImageElement />
      </AnimationContainer>
    </div>
  );
};

LoaderContainer.defaultProps = {
  isLoading: false,
  isPreloader: false,
};

export default LoaderContainer;
